/*
 forked HEAVILY by jason, DO NOT replace
*/
angular.module('ui.slider', []).value('uiSliderConfig',{}).directive('uiSlider', ['uiSliderConfig', '$timeout', '$filter', function(uiSliderConfig, $timeout, $filter) {
  uiSliderConfig = uiSliderConfig || {};
		return {
			require: 'ngModel',
			scope: {
				onStop: '&slideStop',
        config: '=',
        max:    '=',
        min:    '=',
        steps:  '='
			},
			compile: function () {
				return function (scope, elm, attrs, ngModel) {

					function parseNumber(n, decimals) {
						return (decimals) ? parseFloat(n) : parseInt(n);
					};

          // convenience properties
          var properties = ['min', 'max', 'step'];
					var options = angular.extend(scope.$eval(attrs.uiSlider) || {}, uiSliderConfig);
					// Find out if decimals are to be used for slider
          var useDecimals = angular.isDefined(attrs.useDecimals) && attrs.useDecimals == "true";

					var init = function() {
						elm.slider(options);
					};

          var showAmount = function(amount) {
            if (typeof attrs.uiSliderAmount !== "undefined" && typeof scope.config !== "undefined") {
              var computedAmount = $filter('ProductMoney')(scope.steps ? scope.steps[amount] : amount, scope.config, useDecimals ? 2 : 0);
              $(elm).find('.ui-slider-handle').html(computedAmount);
            }
          };

					attrs.$observe('disabled', function(newVal){
						init();
						elm.slider('option', 'disabled', !!newVal);
					});

					// Watch ui-slider (byVal) for changes and update
					scope.$watch(attrs.uiSlider, function(newVal){
						init();
						elm.slider('option', newVal);
					}, true);

					// Late-bind to prevent compiler clobbering
					$timeout(init, 0, true);

					// Update model value from slider
					elm.bind('slide', function(event, ui){
            ngModel.$setViewValue(ui.value);
            showAmount(ui.value);
            scope.$apply();
          });

					elm.bind('slidestop', function(event, ui){
						scope.onStop();
					});

					// Update slider from model value
					ngModel.$render = function(){
            init();
						if (!isNaN(ngModel.$modelValue)) {
  						showAmount(ngModel.$modelValue);
              elm.slider('option', 'value', ngModel.$modelValue);
            }
					};

					scope.$watch(attrs.ngModel, function(){
            ngModel.$render();
          }, true);

          scope.$watch('min', function(newValue, oldValue){
            if (typeof newValue !== 'undefined') {
              init();
              elm.slider('option', 'min', parseNumber(newValue, useDecimals));
            }
          });

          scope.$watch('max', function(newValue, oldValue){
            if (typeof newValue !== 'undefined') {
              init();
              elm.slider('option', 'max', parseNumber(newValue, useDecimals));
            }
          });

          scope.$watch('steps', function(newVal, oldValue) {
            showAmount(ngModel.$modelValue)
          });

					function destroy(){
						elm.slider('destroy');
					}
					elm.bind('$destroy', destroy);

          $.widget( "ui.slider", $.ui.slider, {
            "_trimAlignValue": function (val) {
              if (val <= this._valueMin()) return this._valueMin();
              if (val >= this._valueMax()) return this._valueMax();
              var step = (this.options.step > 0) ? this.options.step : 1,
                         valModStep = (val - this._valueMin()) % step,
                         alignValue = val - valModStep;

              if (Math.abs(valModStep) * 2 >= step) {
                alignValue += (valModStep > 0) ? step : (-step);
              }
              if (alignValue <= this._valueMin()) return this._valueMin();
              if (alignValue >= this._valueMax()) return this._valueMax();
              return parseFloat(alignValue.toFixed(5));
            }
          });
				};
			}
		};
	}]);
